export default {"src":"/_next/static/media/BSX.08da65df.svg","height":18,"width":18};